// extracted by mini-css-extract-plugin
module.exports = {"crossSiteLabel":"ci","zenCrossSiteLabel":"di","vrsnlCrossSiteLabel":"ei"};